import { InvalidProjectError } from '../../domain/errors/InvalidProjectError';
import type { ProjectsRepository } from '../../domain/repositories/ProjectsRepository.interface';
import type { ProjectDto } from '../dto/ProjectDto';
import { ApplicationError, ValidationError, type Logger } from '@dma/shared';

export class GetProjectBySlugUseCase {
  constructor(
    private readonly repository: ProjectsRepository,
    private readonly logger: Logger
  ) {}

  public async execute(slug: string): Promise<ProjectDto> {
    let project;
    try {
      project = await this.repository.getBySlug(slug);
    } catch (error) {
      if (error instanceof InvalidProjectError) {
        this.logger.error('Project content failed domain validation', {
          slug,
          code: error.code,
          message: error.message
        });
        throw new ApplicationError('PROJECT_UNAVAILABLE', 'این پروژه در حال حاضر در دسترس نیست.', {
          cause: error
        });
      }
      throw error;
    }

    if (!project) {
      throw new ValidationError(`پروژه‌ای با شناسه‌ی "${slug}" یافت نشد.`);
    }

    return project.props;
  }
}
